import { BACKFILL_CONSOLES_VOCABULARIES } from './backfill-consoles.js';
/** Slice "consoles" of the catalog (D577): the codes the PDV, merchant, fleet and Central consoles had translated in their own maps. */
export const SLICE_CONSOLES = [...BACKFILL_CONSOLES_VOCABULARIES];
//# sourceMappingURL=slice-consoles.js.map